import React from 'react';
import styled from 'styled-components';
import { AnimatePresence } from "framer-motion"

import { FaChevronUp, FaChevronDown, FaPlusCircle } from 'react-icons/fa'
import { Paper, PopOut, Animation, Button } from 'components'
import InsertOptions from './InsertOptions'

import { EditorState } from 'draft-js';

const Container = styled.div`
    width: ${props => props.width};
    margin-right: 0.1rem;
`

const SelectDropdown = styled.div`
    box-sizing: border-box;
    cursor: pointer;
    color: var(--text-color);
    outline: none;
    font-size: 0.9rem;
    line-height: 0.9rem;
    padding: 0.5rem 0.7rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    vertical-align: middle;
    border-radius: 5px;
    background-color: ${props => props.styles.primaryColor};
    width: 8rem;
    :hover {
        filter: brightness(var(--brightness));
    }
`

const SelectButton = styled.div`
    height: 100%;
    padding: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 50%;
    /* background-color: var(--primary-color); */
    color: var(--secondary-accent-color);
    :hover {
        filter: brightness(var(--brightness));
    }
`

const Text = styled.div`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`

const Icon = styled.div`
    color: var(--secondary-accent-color);
    font-size: var(--icon-size);
    margin: 0 0rem 0 0.3rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
`

const defaultStyles = {
    primaryColor: 'var(--primary-color)'
}

const InsertBlock = props => {
    const {
        onSelect,
        disableDropdown,
        styles
    } = props;
    const updatedStyles = Object.assign({}, defaultStyles, styles)
    const [open, setOpen] = React.useState(false)
    const [option, setOption] = React.useState('default')

    const onOpen = (event) => {
        event.preventDefault()
        !open && setOption('default')
        setOpen(!open)
    }
    // return (
    //     <Container width={!disableDropdown ? '8rem' : 'auto'}>
    //         <PopOut trigger='leftClick' placement='bottom'  animation='dropdown' 
    //             element={<InsertOptions onSelect={onSelect} option={option} setOption={setOption} styles={updatedStyles}/>}>
    //             {!disableDropdown?
    //             <Paper>
    //                 <SelectDropdown onClick={onOpen} styles={updatedStyles}>
    //                     <Text>Insert</Text>
    //                     <Icon>{open ? <FaChevronUp/> : <FaChevronDown/>}</Icon>
    //                 </SelectDropdown>
    //             </Paper>  
    //             : <SelectButton onClick={onOpen} style={{flexShrink: 4}}><FaPlusCircle/></SelectButton>}              
    //         </PopOut>
    //     </Container>
    // )

    return (
        <Button icon={<FaPlusCircle/>} 
            contextMenu={<InsertOptions onSelect={onSelect} option={option} setOption={setOption} styles={updatedStyles}/>}/>
    )
}

export default InsertBlock